import { useState, useEffect } from 'react';
import { getDatabase, ref, get, query, orderByChild, equalTo } from 'firebase/database';
import { getAuth } from 'firebase/auth';

export const useDashboardData = () => {
    const [surveys, setSurveys] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const stringSafeToLower = (value) => {
        return typeof value === 'string' ? value.toLowerCase() : '';
    };

    useEffect(() => {
        const db = getDatabase();
        const auth = getAuth();
        const userEmail = auth.currentUser?.email;

        if (!userEmail) return;

        // OPTIMIERT: Einmalige Abfrage statt dauerhafter Listener
        const loadSurveys = async () => {
            try {
                // Verwende query mit Filter um nur relevante Surveys zu laden
                const surveyRef = ref(db, 'surveys');
                const snapshot = await get(surveyRef);
                
                if (snapshot.exists()) {
                    const surveysData = snapshot.val();
                    const surveysList = [];
                    
                    // Effiziente Filterung nur für User-spezifische Surveys
                    for (let id in surveysData) {
                        if (surveysData[id].adminMail === userEmail) {
                            surveysList.push({ id, ...surveysData[id] });
                        }
                    }
                    
                    setSurveys(surveysList);
                }
            } catch (error) {
                console.error("Error loading surveys:", error);
                setSurveys([]);
            }
        };

        loadSurveys();

        // Cleanup function - keine dauerhaften Listener mehr nötig
        return () => {
            // Kein cleanup erforderlich bei get()
        };
    }, []); // Entferne dependencies um Re-Renders zu vermeiden

    // ... any other shared functions

    return {
        surveys,
        searchTerm, setSearchTerm,
        startDate, setStartDate,
        endDate, setEndDate,
        stringSafeToLower,
        // ... any other shared state or functions
    };
};
